(function(root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.McDuffySubscriptionCheckout = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
  'use strict';

  var PRICE_BY_RECIPE = Object.freeze({
    surf_turf: 259,
    farmyard_feast: 259,
    coastal_blend: 259,
    chicken_rice: 259,
    beef_rice: 259,
    pork_rice: 259
  });
  var SUB_DISCOUNT = 1.00;
  var SUB_PRICE_BY_RECIPE = Object.freeze({
    surf_turf: 259,
    farmyard_feast: 259,
    coastal_blend: 259,
    chicken_rice: 259,
    beef_rice: 259,
    pork_rice: 259
  });
  var SUBSCRIPTION_CATALOG_VERSION = 'unified_259_v3';
  var INTRO_DISCOUNT = 0.60;
  var RECIPE_TITLES = Object.freeze({
    surf_turf: 'Surf & Turf',
    farmyard_feast: 'Farmyard Feast',
    coastal_blend: 'Coastal Blend',
    chicken_rice: 'Chicken It Up',
    beef_rice: 'Braised Beef Bowl',
    pork_rice: 'Hearty Pork Rice'
  });
  var RECIPE_ORDER = Object.freeze(['chicken_rice', 'beef_rice', 'pork_rice', 'surf_turf', 'coastal_blend', 'farmyard_feast']);
  var RECIPE_META = Object.freeze({
    chicken_rice: Object.freeze({ allergens: ['chicken', 'pork', 'grains'] }),
    beef_rice: Object.freeze({ allergens: ['beef', 'grains'], adultOnly: true }),
    pork_rice: Object.freeze({ allergens: ['pork', 'grains'], adultOnly: true }),
    surf_turf: Object.freeze({ allergens: ['beef', 'fish'] }),
    coastal_blend: Object.freeze({ allergens: ['fish', 'grains'] }),
    farmyard_feast: Object.freeze({ allergens: ['chicken', 'pork', 'fish'] })
  });

  function getPricePerBag(recipe) {
    return PRICE_BY_RECIPE[recipe] || 259;
  }

  /* Subscription bulk benefit REMOVED 2026-07-14 (owner): recurring food is now
     FULL LIST price at every quantity. Kept as a 0-returning stub so existing
     imports/exports don't break. getIntroPricePerBag (× 0.60) now yields exactly
     40% off the unified ₱259 subscription price (₱155.40). The one-time
     7/14/21/28 volume ladder is a SEPARATE, KEPT feature. */
  function subscriptionBulkDiscountForBags(totalBags) {
    return 0;
  }

  function getSubPricePerBag(recipe, totalBags) {
    return SUB_PRICE_BY_RECIPE[recipe] || 259;
  }

  function getIntroPricePerBag(recipe, totalBags) {
    return Math.round(getSubPricePerBag(recipe, totalBags) * INTRO_DISCOUNT * 100) / 100;
  }

  function isNoIntroMode(cfg) {
    var mode = String((cfg && (cfg.billingMode || cfg.billing_mode)) || '').toLowerCase();
    return cfg && (
      cfg.introEligible === false ||
      cfg.forceFullPrice === true ||
      cfg.restoreFullPrice === true ||
      mode === 'full_price_rebuild' ||
      mode === 'restore' ||
      mode === 'no_intro'
    );
  }

  function recipeBreakdownText(d) {
    d = d || {};
    var rg = d.recipeGrams || null;
    if (d.recipeBags && typeof d.recipeBags === 'object' && Object.keys(d.recipeBags).length > 1) {
      return Object.keys(d.recipeBags).map(function(r) {
        var gramsNote = (rg && rg[r]) ? ' (' + rg[r] + 'g/day)' : '';
        return d.recipeBags[r] + ' \u00d7 ' + (RECIPE_TITLES[r] || r) + gramsNote;
      }).join(' + ');
    }
    var singleGrams = (rg && rg[d.recipe]) ? ' (' + rg[d.recipe] + 'g/day)' : '';
    return d.qty + ' \u00d7 ' + (RECIPE_TITLES[d.recipe] || 'Fresh Food') + singleGrams;
  }

  function recipeRestrictionForDog(dog, recipeKey, fallbackProfile) {
    dog = dog || {};
    var profile = dog.dogProfile || fallbackProfile || {};
    var meta = RECIPE_META[recipeKey] || { allergens: [] };
    var rawAge = dog.age != null ? dog.age : profile.age;
    var ageMonths = null;
    if (rawAge !== '' && rawAge != null && isFinite(Number(rawAge))) {
      var unit = String(dog.ageUnit || profile.ageUnit || 'years').toLowerCase();
      ageMonths = unit.indexOf('month') === 0 ? Number(rawAge) : Number(rawAge) * 12;
    }
    if (meta.adultOnly && ageMonths != null && ageMonths < 12) return 'For adult dogs 1 year and older';

    var rawAvoided = profile.allergyIngredients || profile.allergies || dog.allergies || [];
    if (!Array.isArray(rawAvoided)) rawAvoided = [rawAvoided];
    var avoided = rawAvoided.map(function(item) {
      return String(item || '').trim().toLowerCase();
    }).filter(Boolean);
    var conflict = (meta.allergens || []).find(function(allergen) {
      return avoided.indexOf(allergen) !== -1;
    });
    return conflict ? 'Unavailable for selected ' + conflict + ' sensitivity' : '';
  }

  function roundMoney(n) {
    return Math.round((Number(n) || 0) * 100) / 100;
  }

  function toCentavos(n) {
    return Math.round((Number(n) || 0) * 100);
  }

  function formatPeso(n) {
    var value = roundMoney(n);
    var hasCentavos = Math.abs(value - Math.round(value)) > 0.001;
    return '\u20B1' + value.toLocaleString('en-PH', {
      minimumFractionDigits: hasCentavos ? 2 : 0,
      maximumFractionDigits: hasCentavos ? 2 : 0
    });
  }

  function normalizeUpsellBilling(u) {
    if (u && u.recurring === false) return 'one_time';
    var billing = String((u && (u.billing || u.billingMode || u.billing_type)) || '').toLowerCase().replace(/[\s-]+/g, '_');
    if (billing === 'one_time' || billing === 'first_box_only' || billing === 'first_order_only') return 'one_time';
    if (billing === 'subscription' || billing === 'monthly' || (u && u.recurring === true)) return 'subscription';
    var text = String((u && (u.variantTitle || u.name || u.title || u.handle)) || '').toLowerCase();
    return text.indexOf('one time') !== -1 || text.indexOf('one-time') !== -1 || text.indexOf('first box only') !== -1
      ? 'one_time'
      : 'subscription';
  }

  function isOneTimeUpsell(u) {
    return normalizeUpsellBilling(u) === 'one_time';
  }

  function upsellBillingLabel(u) {
    return isOneTimeUpsell(u) ? 'First box only' : 'Monthly add-on';
  }

  function getLineItemUnitPrice(item) {
    return roundMoney(
      item && item.priceSet && item.priceSet.shopMoney
        ? item.priceSet.shopMoney.amount
        : (item && item.price) || 0
    );
  }

  return Object.freeze({
    PRICE_BY_RECIPE: PRICE_BY_RECIPE,
    SUBSCRIPTION_CATALOG_VERSION: SUBSCRIPTION_CATALOG_VERSION,
    SUB_DISCOUNT: SUB_DISCOUNT,
    SUB_PRICE_BY_RECIPE: SUB_PRICE_BY_RECIPE,
    INTRO_DISCOUNT: INTRO_DISCOUNT,
    RECIPE_TITLES: RECIPE_TITLES,
    RECIPE_ORDER: RECIPE_ORDER,
    RECIPE_META: RECIPE_META,
    subscriptionBulkDiscountForBags: subscriptionBulkDiscountForBags,
    getPricePerBag: getPricePerBag,
    getSubPricePerBag: getSubPricePerBag,
    getIntroPricePerBag: getIntroPricePerBag,
    isNoIntroMode: isNoIntroMode,
    recipeBreakdownText: recipeBreakdownText,
    recipeRestrictionForDog: recipeRestrictionForDog,
    roundMoney: roundMoney,
    toCentavos: toCentavos,
    formatPeso: formatPeso,
    normalizeUpsellBilling: normalizeUpsellBilling,
    isOneTimeUpsell: isOneTimeUpsell,
    upsellBillingLabel: upsellBillingLabel,
    getLineItemUnitPrice: getLineItemUnitPrice
  });
});
